import { GET_SILENCER } from '../../constants/ActionTypes';

const initialState = {
  items: [],
  loaded: false,
  loading: false,
  error: null,
};

export default function silencer(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SILENCER}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SILENCER}_SUCCESS`:
      return {
        ...state,
        result: structuredClone(action.result?.silencer),
        error: null,
        loaded: true,
        loading: false,
      };
    case `${GET_SILENCER}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
